/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      window.navHeight = $( '.navbar' ).outerHeight();
      if ( $( 'body' ).hasClass( 'admin-bar' ) ) {
        window.navHeight += $( '#wpadminbar' ).outerHeight();
      }

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.js-init-inline' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( document ).on( 'click', '.exit-quoter', function() {
        window.location.assign( '/' );
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      // when new page is loaded (not initial page)
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        // Scroll to top if not the newsletter signup
        if ( window.innerWidth > 1023 ) {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        } else {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        }
      } );
      function lazyload() {
        if ( lazyloadThrottleTimeout ) {
          clearTimeout( lazyloadThrottleTimeout );
        }

        lazyloadThrottleTimeout = setTimeout( function() {
          const scrollTop = window.pageYOffset;
          lazyloadImages.forEach( function( img ) {
            if ( img.offsetTop < ( window.innerHeight + scrollTop ) ) {
              img.src = img.dataset.src;
              img.classList.remove( 'lazy' );
            }
          } );
          if ( lazyloadImages.length == 0 ) {
            document.removeEventListener( 'scroll', lazyload );
            window.removeEventListener( 'resize', lazyload );
            window.removeEventListener( 'orientationChange', lazyload );
          }
        }, 20 );
      }
      document.addEventListener( 'DOMContentLoaded', function() {
        let lazyloadImages;

        if ( 'IntersectionObserver' in window ) {
          lazyloadImages = document.querySelectorAll( '.lazy' );
          const imageObserver = new IntersectionObserver( function( entries, observer ) {
            entries.forEach( function( entry ) {
              if ( entry.isIntersecting ) {
                const image = entry.target;
                image.classList.remove( 'lazy' );
                imageObserver.unobserve( image );
              }
            } );
          } );

          lazyloadImages.forEach( function( image ) {
            imageObserver.observe( image );
          } );
        } else {
          let lazyloadThrottleTimeout;
          lazyloadImages = document.querySelectorAll( '.lazy' );

          lazyload();

          document.addEventListener( 'scroll', lazyload );
          window.addEventListener( 'resize', lazyload );
          window.addEventListener( 'orientationChange', lazyload );
        }
      } );
      const switchImageSrc = ( target ) => {
        const images = $( target ).find( '.ll-lazy' );

        images.each( function( index, element ) {
          if ( $( element ).hasClass( 'll-lazy' ) ) {
            const source = $( element ).attr( 'data-src' );
            $( element ).attr( 'src', source );
            $( element ).removeClass( 'll-lazy' );
          }
        } );
      };

      // add event listener to switch any images with custom lazy load
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        const target = $( event.target ).attr( 'data-lazy' );
        // load images
        switchImageSrc( target );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
